export default __webpack_public_path__ + "static/media/53.b03eebc5.png";